import {ExplorerView} from '@/types';
import { ApiBaseService, ApiV2Service } from '@/services/api.base.service';
import store from '@/store/store';

export class ExplorerService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getAllExplorerViewConfigurations(): Promise<ExplorerView[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/explorer`);
  }

  public async getExplorerViewConfiguration(configId: number): Promise<ExplorerView> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/explorer/${configId}`);
  }

  public async addExplorerViewConfiguration(viewConfiguration: ExplorerView): Promise<ExplorerView> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.post(`organisation/${organisation}/explorer`, viewConfiguration);
  }

  public async updateExplorerViewConfiguration(viewConfiguration: ExplorerView): Promise<ExplorerView> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.put(`organisation/${organisation}/explorer/${viewConfiguration.id}`, viewConfiguration);
  }

  public async deleteExplorerViewConfiguration(configId: number): Promise<boolean> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.delete(`organisation/${organisation}/explorer/${configId}`);
  }

  public async export(configId: number, datasetId: string, options: Record<string, any>): Promise<{ job_id: string}> {
    const organisation = store.getters.activeOrganisation[0];
    const payload = {
      datasetId,
      orgSlug: organisation.slug,
      organisationId: organisation.id,
      options,
    };
    return this.api.post(`organisation/${organisation.id}/explorer/export/${configId}`, payload);
  }
}

export default new ExplorerService();
